export default "__VITE_ASSET__BmOrGA8V__"